export default __webpack_public_path__ + "static/media/enabill.da57b6fb.svg";